// Import model
import { LocationDistanceFieldOptions } from '../models/LocationDistanceFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LocationDistanceFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class LocationDistanceFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a LocationDistanceFieldOptions instance
   */
  static deserialize(json: string): LocationDistanceFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LocationDistanceFieldOptions instance
   */
  static fromObject(obj: any): LocationDistanceFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LocationDistanceFieldOptions');
    }


    const instance: LocationDistanceFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _6368Ddec: obj['_6368ddec'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LocationDistanceFieldOptions instances
   */
  static deserializeArray(json: string): LocationDistanceFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LocationDistanceFieldOptions instance to a JSON string
   */
  static serialize(instance: LocationDistanceFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LocationDistanceFieldOptions instance to a plain object
   */
  static toObject(instance: LocationDistanceFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_6368ddec': instance._6368Ddec,
    };
  }

  /**
   * Serializes an array of LocationDistanceFieldOptions instances to a JSON string
   */
  static serializeArray(instances: LocationDistanceFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
